export default "__VITE_ASSET__DtfcCwjG__"